import React, { useEffect, useRef } from "react";
import { Root } from "./style";

import Modal from "../../Modal";

import { useWeb3 } from "web3";

const Wallet = () => {
  const { activate, wallet, disconnect } = useWeb3();
  const usedRef = useRef();

  useEffect(() => {
    if (!wallet) {
      activate();
    }
  }, []);

  return (
    <Root>
      {wallet ? (
        <div className="connected">
          <span>{wallet.account}</span>
          <small className="close" onClick={disconnect} />
        </div>
      ) : (
        <div className="connect" onClick={() => usedRef.current.connect()}>
          <span>Connect wallet</span>
        </div>
      )}
      <div className="search" onClick={() => usedRef.current.search()}>
        <span>Enter wallet address</span>
      </div>
      <Modal usedRef={usedRef} />
    </Root>
  );
};

export default Wallet;
